<template>
  <div>
    <attendee-select
      multiple
      :disabled="$attrs.disabled"
      rules="required"
      :filter="{bookedMyEvents:true}"
      :attendee.sync="campaign.attendees"
    />
  </div>
</template>

<script>
import AttendeeSelect from '../Attendees/AttendeeSelect.vue'

export default {
  name: 'CampaignSendInputs',
  components: { AttendeeSelect },
  props: {
    campaign: { type: Object, default: () => {} },
  },
}
</script>

<style>

</style>
